<template functional>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="props.size" :height="props.size" viewBox="0 0 16 16">
    <g transform="translate(8771 14353)">
      <g transform="translate(-8769.72 -14351.667)">
        <path d="M9.4,15.8A6.4,6.4,0,1,0,3,9.4,6.4,6.4,0,0,0,9.4,15.8Z" transform="translate(-3 -3)" fill="none" stroke="#4480ae" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" :style="{ fill: 'none !important' }" />
        <path d="M12,7.5v3.467" transform="translate(-5.6 -4.3)" fill="none" stroke="#4480ae" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" :style="{ fill: 'none !important' }" />
        <path d="M11.369,16.364a.869.869,0,1,0-.869-.869A.869.869,0,0,0,11.369,16.364Z" transform="translate(-4.969 -5.964)" fill="#4480ae" :style="{ fill: 'none !important' }" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconCircleInfo',

  props: {
    size: { type: [String, Number], default: '16px' },
  }
}
</script>